import { render, staticRenderFns } from "./ContactoPaciente.vue?vue&type=template&id=09aeef47&scoped=true"
import script from "./ContactoPaciente.vue?vue&type=script&lang=js"
export * from "./ContactoPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aeef47",
  null
  
)

export default component.exports